'use strict';

const checkoutPlaceholderElementID = '#checkoutApp';

const checkoutApp = {
    init: () => {
        if (shouldInit()) {
            createCheckoutApp();
        }
    }
};

const shouldInit = () => {
    return document.querySelectorAll(checkoutPlaceholderElementID).length > 0;
};

const createCheckoutApp = () => {
    const TopErrorMessage = require('./top-error-message/top-error-message.vue');
    const Vue = require('vue');
    const store = require('./store/index');
    const OrderSummary = require('./order-summary/order-summary.vue');
    const OrderOverviewDesktop = require('./order-overview/order-overview-desktop.vue');
    const OrderOverviewMobile = require('./order-overview/order-overview-mobile.vue');
    const Delivery = require('./delivery/delivery.vue');
    const CustomerDetails = require('./details/details.vue');
    const Payments = require('./payments/payments-block.vue');
    const PlaceOrderBlock = require('./place-order/place-order-block.vue');
    const BonusProductUtil = require('./bonus-product-util');

    const InputFacade = require('vue-input-facade').default;
    Vue.use(InputFacade, {
        tokens: {
            '0': { pattern: /\d/ },
            'X': {
                pattern: /[0-9a-zA-Z]/,
                transform: (c) => c.toUpperCase()
            },
        }
    });

    return new Vue({
        el: checkoutPlaceholderElementID,
        store,
        components: {
            Delivery,
            CustomerDetails,
            OrderSummary,
            OrderOverviewDesktop,
            OrderOverviewMobile,
            Payments,
            TopErrorMessage,
            PlaceOrderBlock
        },
        mixins: [BonusProductUtil]
    });
};

module.exports = checkoutApp;
